
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns44aa1335739fdde7a6de74fb4c59671aen from './en.yaml'
            i18n.addResourceBundle('en', '44aa1335739fdde7a6de74fb4c59671a', flattenObject(ns44aa1335739fdde7a6de74fb4c59671aen), true, true);
        
        export default '44aa1335739fdde7a6de74fb4c59671a';
    